import React, { useState, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import { Redirect } from "react-router-dom";
import Spinner from "../common/Spinner";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappIcon,
  WhatsappShareButton,
  TelegramShareButton,
  TelegramIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";

const GET_PRODUCTS = gql`
  {
    products {
      title
      slug
      coverImage {
        url
      }
      url
    }
  }
`;

const GET_POST = gql`
  query GetProduct($path: String!) {
    products(where: { url: $path }) {
      title
      slug
      coverImage {
        url
      }
      content {
        html
      }
      siteTitle
      siteDescription
      url
    }
  }
`;

function renderProduct(product, isMobile, setVariables) {
  if (product) {
    setVariables({
      blogTitle: product.title,
      siteTitle: product.siteTitle,
      siteDescription: product.siteDescription,
      url: `https://www.jetminds.de${product.url}`,
    });
    return (
      <React.Fragment>
        <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"} blog`}>
          {product.slug}
        </h1>
        <div className="section">
          <div className="row">
            <div className="col s12 m12">
              <img
                className="responsive-img"
                src={product.coverImage.url}
                alt={`JetMinds ${product.title}`}
              />
            </div>
            <div
              className="col s12 m12"
              dangerouslySetInnerHTML={{ __html: product.content.html }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function renderReadMore(products) {
  return products.map((item) => {
    return (
      <div key={item.url} className="col s12 m12">
        <div className="card">
          <div className="card-image">
            <a href={item.url}>
              <img
                className="activator"
                src={item.coverImage && item.coverImage.url ? item.coverImage.url : ""}
                alt={item.slug}
                loading="lazy"
              />{" "}
            </a>
          </div>
          <div className="card-content">
            <p>{item.title}</p>
          </div>
        </div>
      </div>
    );
  });
}

function GetProducts(props) {
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loaded, setloaded] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const { loading, error, data } = useQuery(GET_POST, {
    variables: { path: props.path },
  });
  const loadingAllProducts = useQuery(GET_PRODUCTS).loading;
  const errorAllProducts = useQuery(GET_PRODUCTS).error;
  const dataAllProducts = useQuery(GET_PRODUCTS).data;

  useEffect(() => {
    const fetchProduct = () => {
      const fetchedProduct = data;
      if (data) {
        setProducts(fetchedProduct.products);
        setloaded(true);
      }
    };
    const fetchProducts = () => {
      const fetchedProducts = dataAllProducts;
      if (dataAllProducts) {
        let newProducts = [];
        if (fetchedProducts.products.length <= 3) {
          newProducts = fetchedProducts.products;
        } else if (data) {
          while (newProducts.length < 3) {
            const randomProduct =
              fetchedProducts.products[
                Math.floor(Math.random() * fetchedProducts.products.length)
              ];
            if (
              newProducts.indexOf(randomProduct) === -1 &&
              randomProduct.url !== data.products[0].url
            ) {
              newProducts.push(randomProduct);
            }
          }
        }
        setAllProducts(newProducts);
        setAllLoaded(true);
      }
    };
    fetchProduct();
    fetchProducts();
  }, [data, dataAllProducts]);

  if (loading || loadingAllProducts) return <Spinner />;
  if (error || errorAllProducts) return <p>Ein Fehler ist aufgetreten :(</p>;
  return (
    <div className="container">
      <div className="section">
        {props.isMobile || props.isTablet ? (
          <div className="row">
            <div className="col s12 m12">
              {loaded && products.length === 0 && allLoaded ? (
                <Redirect to="/blog" />
              ) : (
                renderProduct(products[0], props.isMobile, props.setVariables)
              )}
            </div>
            <div className="col s12 m12 center">
              <h5>Produkt teilen</h5>
            </div>
            {products[0] ? (
              <div className="col s12 m12 center">
                <FacebookShareButton
                  quote={`${products[0].title}${"\n"}${products[0].siteDescription}`}
                  url={`https://www.jetminds.de${products[0].url}`}
                  style={{ padding: 3 }}
                >
                  <FacebookIcon round size={40} />
                </FacebookShareButton>
                <TwitterShareButton
                  title={`${products[0].title}${"\n"}${
                    products[0].siteDescription
                  }${"\n"}`}
                  via="JetMinds_de"
                  related={["JetMinds_de"]}
                  style={{ padding: 3 }}
                  url={`https://www.jetminds.de${products[0].url}`}
                >
                  <TwitterIcon round size={40} />
                </TwitterShareButton>
                <LinkedinShareButton
                  title={`${products[0].title}`}
                  summary={`${products[0].siteDescription}`}
                  style={{ padding: 3 }}
                  source={`https://www.jetminds.de${products[0].url}`}
                  url={`https://www.jetminds.de${products[0].url}`}
                >
                  <LinkedinIcon round size={40} />
                </LinkedinShareButton>
                <WhatsappShareButton
                  title={`${
                    products[0].title
                  }${"\n\n"}Ich habe diesen Produkt bei JetMinds gefunden. Wie findest Du das?`}
                  separator={"\n\n"}
                  url={`https://www.jetminds.de${products[0].url}`}
                  style={{ padding: 3 }}
                >
                  <WhatsappIcon round size={40} />
                </WhatsappShareButton>
                <TelegramShareButton
                  title={`${
                    products[0].title
                  }${"\n\n"}Ich habe diesen Produkt bei JetMinds gefunden. Wie findest Du das?`}
                  url={`https://www.jetminds.de${products[0].url}`}
                  style={{ padding: 3 }}
                >
                  <TelegramIcon round size={40} />
                </TelegramShareButton>
                <EmailShareButton
                  subject={`${products[0].title}`}
                  body={`Ich habe diesen Produkt bei JetMinds gefunden. Wie findest Du das? ${"\n"} ${
                    products[0].siteDescription
                  } ${"\n\n"}Hier geht es zum Produkt:`}
                  separator={"\n"}
                  url={`https://www.jetminds.de${products[0].url}`}
                  style={{ padding: 3 }}
                >
                  <EmailIcon round size={40} />
                </EmailShareButton>
              </div>
            ) : null}
            <div className="col s12 m12">
              <h5 style={{ marginTop: "100px" }}>Lesen Sie auch:</h5>
              {renderReadMore(allProducts)}
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="row">
              <div className="col s12 m8">
                {loaded && products.length === 0 && allLoaded ? (
                  <Redirect to="/blog" />
                ) : (
                  renderProduct(products[0], props.isMobile, props.setVariables)
                )}
              </div>
              <div className="col s12 m3 offset-m1">
                <h5 style={{ marginTop: "100px" }}>Lesen Sie auch:</h5>
                {renderReadMore(allProducts)}
              </div>
            </div>
            <div className="row center">
              <div className="col s12 m12">
                <h5>Produkt teilen</h5>
              </div>
              {products[0] ? (
                <div className="col s12 m12 center">
                  <FacebookShareButton
                    quote={`${products[0].title}${"\n"}${
                      products[0].siteDescription
                    }`}
                    url={`https://www.jetminds.de${products[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <FacebookIcon round size={40} />
                  </FacebookShareButton>
                  <TwitterShareButton
                    title={`${products[0].title}${"\n"}${
                      products[0].siteDescription
                    }${"\n"}`}
                    via="JetMinds_de"
                    related={["JetMinds_de"]}
                    style={{ padding: 3 }}
                    url={`https://www.jetminds.de${products[0].url}`}
                  >
                    <TwitterIcon round size={40} />
                  </TwitterShareButton>
                  <LinkedinShareButton
                    title={`${products[0].title}`}
                    summary={`${products[0].siteDescription}`}
                    style={{ padding: 3 }}
                    source={`https://www.jetminds.de${products[0].url}`}
                    url={`https://www.jetminds.de${products[0].url}`}
                  >
                    <LinkedinIcon round size={40} />
                  </LinkedinShareButton>
                  <WhatsappShareButton
                    title={`${
                      products[0].title
                    }${"\n\n"}Ich habe diesen Produkt bei JetMinds gefunden. Wie findest Du das?`}
                    separator={"\n\n"}
                    url={`https://www.jetminds.de${products[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <WhatsappIcon round size={40} />
                  </WhatsappShareButton>
                  <TelegramShareButton
                    title={`${
                      products[0].title
                    }${"\n\n"}Ich habe diesen Produkt bei JetMinds gefunden. Wie findest Du das?`}
                    url={`https://www.jetminds.de${products[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <TelegramIcon round size={40} />
                  </TelegramShareButton>
                  <EmailShareButton
                    subject={`${products[0].title}`}
                    body={`Ich habe diesen Produkt bei JetMinds gefunden. Wie findest Du das? ${"\n"} ${
                      products[0].siteDescription
                    } ${"\n\n"}Hier geht es zum Produkt:`}
                    separator={"\n"}
                    url={`https://www.jetminds.de${products[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <EmailIcon round size={40} />
                  </EmailShareButton>
                </div>
              ) : null}
              <div className="col s2 m2"></div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default GetProducts;



// WEBPACK FOOTER //
// ./src/components/services/application.js